import * as React from 'react';
import { deprecatedComponent } from '../react/components/core/deprecated-component.js';

function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
/**
 * @deprecated
 * use <Icon iconType="" /> instead
 **/ const IconShoppingBag_0 = deprecatedComponent({
    displayName: 'IconShoppingBag_0',
    // @ts-ignore
    root: (props)=>/*#__PURE__*/ React.createElement("svg", _object_spread({
            viewBox: "0 0 38 38",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            width: "1em",
            height: "1em"
        }, props), /*#__PURE__*/ React.createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M10.25 12.5984C10.25 12.1842 10.5858 11.8484 11 11.8484H27C27.4142 11.8484 27.75 12.1842 27.75 12.5984V29.2984C27.75 29.7126 27.4142 30.0484 27 30.0484H11C10.5858 30.0484 10.25 29.7126 10.25 29.2984V12.5984ZM11.75 13.3484V28.5484H26.25V13.3484H11.75Z",
            fill: "black"
        }), /*#__PURE__*/ React.createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M17.8 9.44995C17.5142 9.44995 17.25 9.71416 17.25 9.99995V15.1C17.25 15.5142 16.9142 15.85 16.5 15.85C16.0858 15.85 15.75 15.5142 15.75 15.1V9.99995C15.75 8.88574 16.6858 7.94995 17.8 7.94995H20.4C21.5142 7.94995 22.45 8.88574 22.45 9.99995V15.2C22.45 15.6142 22.1142 15.95 21.7 15.95C21.2858 15.95 20.95 15.6142 20.95 15.2V9.99995C20.95 9.71416 20.6858 9.44995 20.4 9.44995H17.8Z",
            fill: "black"
        })),
    description: 'The Inline SVG Icon API is deprecated, use the Icon component instead'
});

export { IconShoppingBag_0 };
